import clsx from "clsx";

import { DateTimeTz, Icon } from "@web-app/components";
import { OrderTimeline } from "@web-app/types";
import { OrderTimelineSchema, timeZoneMap } from "@web-app/utils/helpers";

type SmsNotificationActivityPropTypes = {
  item: OrderTimeline;
  showTimelineBar: boolean;
  timezone: keyof typeof timeZoneMap | undefined;
};

export default function SmsNotificationActivity({
  item,
  showTimelineBar,
  timezone,
}: SmsNotificationActivityPropTypes) {
  const SmsNotificationIcon =
    OrderTimelineSchema.smsNotification.action.CREATE.icon;
  const smsNotificationColor =
    OrderTimelineSchema.smsNotification.action.CREATE.color;

  return (
    <li key={item.id} className="relative flex gap-x-2 md:gap-x-4">
      <div
        className={clsx(
          showTimelineBar ? "-bottom-6" : "h-6",
          "absolute left-0 top-0 flex w-6 justify-center",
        )}
      >
        <div className="w-px bg-gray-200" />
      </div>
      <div className="relative flex h-7 w-6 flex-none items-center justify-center bg-white">
        <Icon
          name={SmsNotificationIcon}
          className={clsx("h-3 md:h-4", smsNotificationColor)}
        />
      </div>
      <p className="flex-auto flex flex-col items-start py-0.5 text-[10px] md:text-xs leading-0 md:leading-5 text-gray-500">
        <span
          className={clsx(
            "inline-block font-medium text-gray-900",
            smsNotificationColor,
          )}
        >
          {OrderTimelineSchema.smsNotification.action.CREATE.text}{" "}
          {item.updatedValue} event
        </span>
        <span className="relative">
          <DateTimeTz
            start={new Date(item?.createdAt)}
            timezone={timezone}
            createdBy={item?.createdBy?.name}
            presentation="timeline"
          />
        </span>
      </p>
    </li>
  );
}
